import { Fade, Icon } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import useWindowDimensions from "../../../hooks/useWindowDimension";
import { XL_BREAKPOINT } from "../../../config/breakpoints";
import {ROUTES} from "../../../config/site.config";
import Logo from "../../Logo/Logo";
import Drawer from "./Drawer";
import NavLinks from "./NavLinks";


const routes = [{
        label: "FurciFood",
        path: ROUTES.FURCIFOOD_PATH,
    },
    {
        label: "Furcy",
        path: ROUTES.FURCY_PATH
    },
    {
        label: "FurciNet",
        path: ROUTES.FURCINET_PATH,
    },
    // {
    //     label: "Blog",
    //     path: ROUTES.BLOG_PATH,
    // }
];

const NavBar = (props) => {
  const { width } = useWindowDimensions();
  const [position, setPosition] = useState("absolute");
  const { breadcrumbs, accessoryRight } = props;

  const styles = {
    container: {
      position: position,
      width: "100vw",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-around",
      alignSelf: "center",
      top: 0,
      paddingTop: 15,
      paddingBottom: 15,
      zIndex: 3,
      height: 40,
    },
    whiteBackground: {
      backgroundColor: "white",
      position: "absolute",
      width: "100%",
      height: "100%",
      zIndex: 0,
      boxShadow: "0px 10px 15px -5px rgba(0,0,0,0.1)",
    },
    logoContainer: {
      width: "20%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1,
    },
    linkContainer: {
      width: "70%",
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      zIndex: 1,
    },
  };

  const [showBackground, setShowBackground] = useState(true);
  const [showBurger, setShowBurger] = useState(false);
  const [showDrawer, setShowDrawer] = useState(false);

  const handleScroll = () => {
    setShowBackground(true);
    setPosition("fixed");
    // Aggiunta effetto fade su sfondo NavBar
    // if (window.scrollY > 1 && !breadcrumbs) {
      // } else {
    //   setShowBackground(false);
    //   setPosition("absolute");
    // }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (width < XL_BREAKPOINT) {
      setShowBurger(true);
    } else {
      setShowBurger(false);
    }
  }, [width]);

  return (
    <div style={{ ...styles.container, ...props.style }}>
      <Drawer
        routes={routes}
        showDrawer={showDrawer}
        accessoryBottom={accessoryRight}
        handleDrawerClose={() => setShowDrawer(false)}
      />
      <Fade in={showBackground}>
        <div style={styles.whiteBackground} />
      </Fade>
      {showBurger && (
        <div style={{ width: "40%", zIndex: 1 }}>
          <Icon
            style={{
              color:
                breadcrumbs === true ? "#333333" : !showBackground && "white",
              cursor: "pointer",
              fontSize: 35,
              marginLeft: 20,
            }}
            onClick={() => setShowDrawer(true)}
          >
            menu
          </Icon>
        </div>
      )}
      <div style={styles.logoContainer}>
        <Link to={ROUTES.HOME_PATH} style={{ textDecoration: "none" }}>
          <Logo/>
        </Link>
      </div>
      {!showBurger && (
        <div style={styles.linkContainer}>
          <NavLinks
            routes={routes}
            linkColor={props.linkColor || (breadcrumbs ? "#333333" : !showBackground && "white")}
            style={{
              marginRight: 0,
              width: "100%",
              justifyContent: "flex-end",
            }}
          />
          {accessoryRight && accessoryRight}
        </div>
      )}
      {showBurger && <div style={{ width: "40%" }} />}
    </div>
  );
};

export default NavBar;
